<template>
  <div class="login content">
    <h1>{{ $t("login.title") }}</h1>
    <div class="row justify-content-center">
      <div class="col-md-5 position-relative form-login">
        <v-card-text>
          <v-form>
            <v-text-field
              name="email"
              :label="$t('login.email')"
              v-model="email"
              type="text"
            ></v-text-field>
            <v-text-field
              id="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              name="password"
              v-model="password"
              :label="$t('login.password')"
              @keyup.enter="login"
            ></v-text-field>
            <p v-if="error" class="text-red text-center">{{ error }}</p>
          </v-form>
        </v-card-text>
        <router-link
          class="text-center w-100 d-block text-white"
          :to="$t('routes.forgot_password')"
        >
          {{ $t("login.forgot") }}
        </router-link>
        <button class="login-button btn btn-danger" @click="login">
          {{ $t("login.continue") }}
        </button>

        <div class="text-center">
          {{ $t("login.donthave") }}
          <router-link class="text-danger" :to="$t('routes.register')">
            {{ $t("login.create") }}
          </router-link>
        </div>
        <div class="sso text-center pt-4">
          <a v-if="ssoUrl" :href="ssoUrl" class="m-2">
            <apple-s-s-o-icon />
          </a>
          <button @click="launchGoogleSignin" class="m-2">
            <google-s-s-o-icon />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconFacebook from "../../components/icons/iconFacebook.vue";

import { OrizonApiClient } from "../../services/OrizonApiClient";
import { FlixlatinoApiClient } from "@/services/FlixlatinoApiClient";
const flxApiClient = new FlixlatinoApiClient();
import { UserStore } from "@/stores/userStore";
import AppleSSOIcon from "@/components/icons/appleSSOIcon.vue";
import GoogleSSOIcon from "@/components/icons/googleSSOIcon.vue";
import { FirebaseService, ProviderType } from "../../services/FirebaseService";
import Cookie from "@/services/Cookie";
const userStore = UserStore();

const apiClient = new OrizonApiClient();
const firebaseService = new FirebaseService();

export default {
  name: "LoginView",
  components: { AppleSSOIcon, GoogleSSOIcon },
  data() {
    return {
      show1: false,
      ssoUrl: null,
      email: null,
      password: null,
      error: null,
    };
  },
  created() {
    this.mountSSO();
  },
  mounted() {
    this.$meta.canonicalUrls(
      this.$t("routes.login", "es"),
      this.$t("routes.login", "en")
    );
    // Check for firebase redirect result
    firebaseService.handleLoginRedirectResult().then((data) => {
      if (data != null) {
        this.socialLogin(data.type, data.email, data.identifier);
      }
    });
  },
  methods: {
    mountSSO() {
      flxApiClient.get("apple/login").then((response) => {
        if (response.data.status === "success") {
          this.ssoUrl = response.data.url;
        }
      });
    },
    launchGoogleSignin() {
      // Launch firebase google login
      firebaseService.launchGoogleAuth();
    },
    login() {
      this.error = null;
      apiClient
        .login(this.email, this.password)
        .then((response) => {
          if (response.error === null) {
            this.loginResponse(response.data, response.data.token);
          } else {
            console.log(response.error);
            this.error = response.error;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    socialLogin(providerId, email, identifier) {
      if (providerId != ProviderType.google) {
        // Only available for google
        return;
      }

      let request_data = {
        email: email,
      };
      switch (providerId) {
        case ProviderType.google:
          request_data.googleid = identifier;
          break;
      }
      apiClient
        .googleLogin(email, identifier)
        .then((response) => {
          if (response.error === null) {
            this.loginResponse(response.data, response.data.token);
          } else {
            //"If you have already been registered please login and link your account.",
            this.error = this.$t("login.social_login_error"); //response.error;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loginResponse(account, token) {
      userStore.setAccount(account);
      userStore.setToken(token);
      apiClient.setToken(token);

      if (Cookie.getCookie("flx_visited_title_page") !== "") {
        this.$router.push(Cookie.getCookie("flx_visited_title_page"));
      }

      let entryPoint = userStore.getEntrypoint;
      if (entryPoint) {
        console.log("pushing entryPoint", entryPoint);

        this.$router.push(entryPoint);
        userStore.setEntrypoint(null);
      } else {
        console.log("pushing home", entryPoint);
        this.$router.push({ name: "home" });
      }
      console.info("success login entryPoint", entryPoint);
    },
  },
};
</script>

<style lang="scss">
.login {
  background: url("@/assets/img/login-background.png") no-repeat center center;
  background-size: cover;
  height: 100vh;

  .form-login {
    max-width: 600px;
  }

  h1 {
    text-align: center;
    padding: 10vw 0 1em;
    margin: 0;
  }
  .btn {
    padding: 0.7em 2em;
    &.login-button {
      width: 75%;
      margin: 2em auto;
      display: block;
    }
  }
  input[name="email"] {
    border-radius: 16px !important;
  }

  .v-text-field {
    position: relative;

    .v-input__append {
      position: absolute;
      right: 1em;
      top: 1em;

      .mdi-eye {
        background: url("@/assets/img/eye.png") no-repeat center center;
        background-size: contain;
        opacity: 1 !important;
      }
      .mdi-eye-off {
        background: url("@/assets/img/eye-off.png") no-repeat center center;
        background-size: contain;
        opacity: 1 !important;
      }
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:visited,
  input:-webkit-autofill:focus-within,
  input:-webkit-autofill:focus-visible,
  input:-webkit-autofill:target,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
}
</style>
